import { Component, Input, OnInit } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';

@Component({
  selector: 'app-all-props',
  templateUrl: './all-props.component.html',
  styleUrls: ['./all-props.component.scss']
})
export class AllPropsComponent implements OnInit {

  @Input({required:true}) controllers: Controller[];
  searchFilter = '';

  constructor() { }

  ngOnInit(): void {}

  onClear() {
    this.searchFilter = '';
  }

  onChangeSearchInput(event) {
    this.searchFilter = event;
  }

}
